<template>
  <dp-payment-create :subNavTitle="title" :capsule="capsule" :saveMessage="saveMessage"></dp-payment-create>
</template>

<script>
  import CreateTemplate from '../../requests/creationPages/PRCreateTemplate.vue'
  export default {
    name: 'Capsule-Payment-Create',
    data: () => {
      return {
        title: 'New Request to Pay',
        capsule: 'direct-payment-create',
        saveMessage: 'Draft added'
      }
    },
    components: {
      'dp-payment-create': CreateTemplate
    }
  }
</script>



// WEBPACK FOOTER //
// TPayments.vue?63491770